// state/active-lesson-context.ts — Item 2 (founder round-3, 2026-06-11).
//
// The IN-LESSON Prof chat (the swipe-up sheet opened from GuidedLessonScreen)
// must answer as the FULL Prof WITH a lesson BIAS — never lesson-LIMITED, never
// "fuori perimetro" for a driving/exam question. To do that the BE needs the
// student's current lesson position (argomento + chapter). The chat sheet is
// mounted in AppFrame ABOVE <Routes>, so it can't read the lesson's React props.
//
// This tiny store is the seam: the lesson reader PUBLISHES its current context
// (argomento id/name + chapter title/order/count) while mounted, and clears it
// on unmount. GlobalChatSheet reads it and forwards it to ProfChatPanel, which
// attaches it to the /api/chiedi request when the active thread is a lesson
// thread. It is intentionally NOT persisted — it is live, screen-scoped state.

import { create } from 'zustand';

export interface ActiveLessonContext {
  /** The lesson's argomento id (e.g. "arg5"). */
  argomentoId: string;
  /** Human argomento name (e.g. "Le parti della strada") — best-effort. */
  argomentoName?: string;
  /** Human lesson title shown in the current reader. */
  lessonTitle?: string;
  /** The chapter the student is currently reading (title). */
  chapterTitle?: string;
  /** 1-based chapter position. */
  chapterOrder?: number;
  /** Total chapters in the lesson. */
  chapterCount?: number;
  /** Asset refs visible in the current chapter, normalized to repo/public refs. */
  visibleAssetRefs?: string[];
  /** Official or authored question refs visible in the current chapter. */
  questionRefs?: string[];
}

interface ActiveLessonContextState {
  /** The current lesson context, or null when no lesson reader is mounted. */
  context: ActiveLessonContext | null;
  /** Publish/replace the active lesson context (called by the lesson reader). */
  setContext: (ctx: ActiveLessonContext) => void;
  /** Clear the context (called on the lesson reader's unmount). */
  clearContext: () => void;
}

export const useActiveLessonContext = create<ActiveLessonContextState>((set) => ({
  context: null,
  setContext: (ctx) => set({ context: ctx }),
  clearContext: () => set({ context: null }),
}));
